"use client";

import {
  FileEdit,
  Send,
  CheckCircle,
  XCircle,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { ProposalStatus } from "@/types";

interface StatusBadgeProps {
  status: ProposalStatus;
  size?: "sm" | "default";
}

const statusConfig: Record<
  ProposalStatus,
  {
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    variant: "default" | "secondary" | "success" | "destructive" | "outline";
  }
> = {
  draft: {
    label: "Brouillon",
    icon: FileEdit,
    variant: "secondary",
  },
  sent: {
    label: "Envoyée",
    icon: Send,
    variant: "default",
  },
  accepted: {
    label: "Acceptée",
    icon: CheckCircle,
    variant: "success",
  },
  rejected: {
    label: "Refusée",
    icon: XCircle,
    variant: "destructive",
  },
};

export function StatusBadge({ status, size = "default" }: StatusBadgeProps) {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge
      variant={config.variant as any}
      className={size === "sm" ? "text-xs gap-1" : "gap-1.5"}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {config.label}
    </Badge>
  );
}
